module.exports = __webpack_public_path__ + "static/media/bgr-one-xxl.26c93ffd.webp";